import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { unwrapResponse } from '~/utils/unwrapResponse';
import { canBeMerchantSlug } from '~/utils/canBeMerchantSlug';
import type { Merchant } from '~~/models/Merchant';

export type MerchantBySlugSearchParams = {
	merchantSlug: MaybeRef<string | undefined>;
};

export const fetchMerchantBySlugFn = async (slug: string) => {
	const { $api } = useNuxtApp();
	return $api
		.GET(`/merchants/{slug}`, {
			params: { path: { slug } },
		})
		.then(unwrapResponse);
};

export const useMerchantBySlugQuery = (
	options: MerchantBySlugSearchParams,
) => {
	const queryClient = useQueryClient();
	const query = useQuery({
		queryKey: ['public-merchant', options.merchantSlug],
		queryFn: () => fetchMerchantBySlugFn(unref(options.merchantSlug)!),
		initialData: () => queryClient.getQueryData<Merchant[]>(['merchants'])
			?.find((c) => c?.id === unref(options.merchantSlug)),
		initialDataUpdatedAt: () =>
			queryClient.getQueryState<Merchant[]>(['merchants'])
				?.dataUpdatedAt,
		enabled: () => {
			const slug = unref(options.merchantSlug);

			return !!slug && canBeMerchantSlug(slug);
		},
	});

	return query;
};
